import type { MenuType } from '@/_types/Shared/SiteDatas';

import CustomLink from './CusomLink';

export default function Menu({ menu }: { menu: MenuType[] | undefined }) {
	return (
		<ul className='flex flex-col gap-1.5'>
			{menu?.map((item: MenuType) => {
				return (
					<li key={item.id} className='flex flex-col gap-7 tablet:gap-1.5'>
						<CustomLink item={item} />
						{item.children && typeof item.children != 'string' && item.children.length > 0 && (
							<ul className='flex flex-col gap-7 pl-2.5 tablet:gap-1.5'>
								{item.children.map((child: MenuType) => {
									return (
										<li key={child.id} className=''>
											<CustomLink item={child} />
										</li>
									);
								})}
							</ul>
						)}
					</li>
				);
			})}
		</ul>
	);
}
